/* import __COLOCATED_TEMPLATE__ from './download-pdf-modal.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { registerDestructor } from '@ember/destroyable';
import type { ConversationPdfDownloadReadyEvent } from 'embercom/services/nexus';
import safeWindowOpen from 'embercom/lib/safe-window-open';

const PDF_EXPORT_TIMEOUT_MS = 30000;

interface Args {
  conversationId: number;
  onClose: () => void;
}

interface Signature {
  Args: Args;
}

export default class DownloadPdfModal extends Component<Signature> {
  @tracked downloadUrl?: string;
  @tracked hasTimedOut = false;

  private timeoutId?: ReturnType<typeof setTimeout>;

  constructor(owner: unknown, args: Args) {
    super(owner, args);

    this.timeoutId = setTimeout(() => {
      this.hasTimedOut = true;
    }, PDF_EXPORT_TIMEOUT_MS);

    registerDestructor(this, () => {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
    });
  }

  @action
  handleNexusEvent(event: ConversationPdfDownloadReadyEvent): void {
    // Only process events for the current conversation
    if (event.eventData.conversation_id === this.args.conversationId) {
      this.downloadUrl = event.eventData.download_url;

      // Clear timeout since we received the event
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = undefined;
      }
    }
  }

  @action
  downloadPdf(): void {
    if (this.downloadUrl) {
      safeWindowOpen(this.downloadUrl, '_blank');
    }
  }

  @action
  onClose(): void {
    this.args.onClose();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Conversation::DownloadPdfModal': typeof DownloadPdfModal;
    'inbox2/conversation/download-pdf-modal': typeof DownloadPdfModal;
  }
}
